package com.example.mystybag.core.expected

import kotlinx.coroutines.CoroutineDispatcher
import kotlinx.coroutines.Dispatchers

actual object CoreDispatchers {
    actual val default: CoroutineDispatcher get() = Dispatchers.Default
}
